export default {
  menuBreakPoint: 768,
  $mainNav: null,
  $submenus: null,
  $triggers: null,
  $mobileMenuTrigger: null,

  resizeEvent: null,
  clickEvent: null,
  keydownEvent: null,

  init() {
    this.$mainNav = document.querySelector(".top-header__primary-nav");
    this.$submenus = this.$mainNav.querySelectorAll(".top-nav .sub-menu");
    this.$triggers = this.$mainNav.querySelectorAll(
      ".top-nav .menu-item-has-children .top-menu-item-link"
    );
    this.$mobileMenuTrigger = document.querySelector(".js-toggle-menu");

    this.$mainNav.addEventListener(
      "click",
      this.handleSubmenuTrigger.bind(this)
    );

    this.$mobileMenuTrigger.addEventListener(
      "click",
      this.toggleMobileMenu.bind(this)
    );

    window.addEventListener("resize", this.closeMobileMenu.bind(this));
    document.addEventListener("keydown", (event) => {
      if (event.keyCode == 27 || event.keyCode == 46) this.closeMobileMenu();
    });

    this.resizeEvent = this.closeOnResize.bind(this);
    this.clickEvent = this.closeOnClickOutside.bind(this);
    this.keydownEvent = this.closeOnKeypress.bind(this);
  },

  toggleMobileMenu() {
    if (this.$mainNav.classList.contains("is-open")) {
      this.$mobileMenuTrigger.setAttribute("aria-expanded", "false");
      this.closeMobileMenu();
    } else {
      this.$mobileMenuTrigger.setAttribute("aria-expanded", "true");
      this.openMobileMenu();
    }
  },

  closeMobileMenu() {
    document.body.classList.remove("menu-is-open");
    this.$mainNav.classList.remove("is-open");
  },

  openMobileMenu() {
    document.body.classList.add("menu-is-open");
    this.$mainNav.classList.add("is-open");
  },

  handleSubmenuTrigger(event) {
    if (
      !event.target.matches(
        ".top-nav .menu-item-has-children .top-menu-item-link"
      )
    )
      return;
    const $trigger = event.target;
    const $submenu = event.target.parentElement.querySelector(".sub-menu");

    if (
      $trigger.getAttribute("aria-expanded") === "false" ||
      !$trigger.getAttribute("aria-expanded")
    ) {
      this.openSubmenu($trigger, $submenu);
    } else {
      this.closeAllSubmenus();
    }
    event.preventDefault();
  },

  openSubmenu($trigger, $submenu) {
    const windowWidth = window.innerWidth;
    // Close all other menus on desktop
    if (windowWidth > this.menuBreakPoint) {
      this.closeAllSubmenus();
    }
    $trigger.setAttribute("aria-expanded", "true");
    $trigger.parentElement.classList.add("has-open-submenu");
    $trigger.parentElement.parentElement.classList.add(
      "has-child-with-open-submenu"
    );
    $submenu.classList.add("is-open");

    // Add Close Event Listeners
    document.addEventListener("click", this.clickEvent, true);
    window.addEventListener("resize", this.resizeEvent, true);
    document.addEventListener("keydown", this.keydownEvent, true);
  },

  closeAllSubmenus() {
    this.$triggers.forEach(function ($trigger) {
      $trigger.setAttribute("aria-expanded", "false");
      $trigger.parentElement.classList.remove("has-open-submenu");
      $trigger.parentElement.parentElement.classList.remove(
        "has-child-with-open-submenu"
      );
    });
    this.$submenus.forEach(function ($submenu) {
      $submenu.classList.remove("is-open");
    });
    // Remove close Event Listeners
    document.removeEventListener("keydown", this.keydownEvent);
    document.removeEventListener("click", this.clickEvent);
    window.removeEventListener("resize", this.resizeEvent);
  },

  closeOnClickOutside(event) {
    if (!event.target.closest(".has-open-submenu")) this.closeAllSubmenus();
  },

  closeOnResize() {
    this.closeAllSubmenus();
  },

  closeOnKeypress(event) {
    // If delete or backspace
    if (event.keyCode == 27 || event.keyCode == 46) this.closeAllSubmenus();
  },
};
